import * as React from "react";

import Link from "@khanacademy/wonder-blocks-link";
import {LabelSmall} from "@khanacademy/wonder-blocks-typography";
import {NoTransYet} from "@khan/i18n";

export default function LicenseText(): React.ReactElement {
    return (
        <LabelSmall>
            <NoTransYet context="Legalese for Python user programs. * This string requires the following tags to be implemented via I18nInlineMarkup: - mitLicenseLink - creativeCommonsLicenseLink - termsOfServiceLink When using this string, please manually test to ensure that hyperlinks appear where the HTML tags are, and no literal HTML tags are visible to users.">
                All code is owned by its respective author and made available
                under the{" "}
                <Link href="https://opensource.org/license/mit/">
                    MIT License
                </Link>
                . All non-code (such as writing, images, etc.) is owned by its
                respective author and made available under the{" "}
                <Link href="https://creativecommons.org/licenses/by/4.0/">
                    Creative Commons Attribution License
                </Link>
                . For more information, please see our{" "}
                <Link href="/about/docs/khan-academy-terms-of-service">
                    Terms of Service
                </Link>
                .
            </NoTransYet>
        </LabelSmall>
    );
}
